// SPEC-OCR-TEST-ENTRYPOINT-DEV-ONLY-01 (D-362): テスト版(preview/development)限定 UI の環境判定ヘルパー。
//   TestBuildWatermark.jsx (D-114) の resolveEnv() と同一ロジックをコピー(TestBuildWatermark 側は変更しない=読むだけ)。
//   vite.config の既存 define `__VERCEL_ENV__` を読む(新規 env 変数なし)。sentry.js/TestBuildWatermark と同じガード形で、
//   undefined 時は安全側=production 扱い(=テスト版限定 UI は非表示)。env 引数はテスト差し替え用の口。
export function resolveBuildEnv() {
  return typeof __VERCEL_ENV__ !== 'undefined' ? __VERCEL_ENV__ : 'production'
}

// production 以外(preview/development)なら true。テスト版限定 UI の表示可否に使う。
export function isTestBuild(env) {
  return (env ?? resolveBuildEnv()) !== 'production'
}
